import {
    validateAction,
    validateActionDueDate,
    validateActionOutcomeDate,
    validateActionTitle
} from './validationFunctions';

export const validate = (newEntry, contractEndDate) => {
    let newErrors = {};

    newErrors = validateActionTitle(newEntry.actionTitle, newErrors);
    newErrors = validateAction(newEntry.action, newErrors);
    newErrors = validateActionDueDate(newEntry.actionDueDate, contractEndDate, newErrors);

    newErrors = validateActionOutcomeDate(
        newEntry.actionOutcomeDate,
        newEntry.actionStartDate,
        newErrors
    );

    return newErrors;
};
